import { cn } from '@/lib/utils';

interface SpinnerRingProps {
  className?: string;
  /** Stroke width in viewBox units (the ring is drawn on a 24x24 grid). */
  strokeWidth?: number;
}

/**
 * SVG circular arc spinner. Replaces the border-based spinner, which renders
 * a stray dark seam in Chromium where differently coloured borders meet while rotating.
 */
export function SpinnerRing({ className, strokeWidth = 2 }: SpinnerRingProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" className={cn('animate-spin', className)}>
      <circle
        cx="12"
        cy="12"
        r="10"
        className="stroke-border"
        strokeWidth={strokeWidth}
      />
      <circle
        cx="12"
        cy="12"
        r="10"
        className="stroke-primary"
        strokeWidth={strokeWidth}
        pathLength={100}
        strokeDasharray="25 75"
        strokeLinecap="round"
      />
    </svg>
  );
}
